import { SpaceXxs, SpaceMd } from "@nxt-costco-com/forge-design-tokens";
const bannerWrapperStyles = {
  padding: { md: 0, xs: SpaceMd },
  paddingTop: { md: SpaceXxs }
};
export {
  bannerWrapperStyles
};
